import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ConfirmationService } from 'primeng/api';
import { Constants } from 'src/app/models/constants';
import { EncryptDecryptService } from 'src/app/services/encrypt-decrypt.service';
import { StorageService } from 'src/app/services/storage.service';

@Component({
  selector: 'app-prenavbar',
  standalone: false,
  templateUrl: './prenavbar.component.html',
  styleUrls: ['./prenavbar.component.scss'],
})
export class PrenavbarComponent implements OnInit {
  title = 'EY Global Tax E-Invoicing Solution';

  interval: any;
  selectedCountry: string = "default";
  showError: boolean = false;

  constructor(
    private router: Router,
    private storageService: StorageService,
    private confirmationService: ConfirmationService,
    private encryptDecryptService: EncryptDecryptService) {

  }

  ngOnInit() {
    this.encryptDecryptService.resetPassPhrase();
  }

  redirectDashboard() {
    switch (this.selectedCountry) {
      case 'default':
        this.showError = true;
        break;
      case 'IN':
        window.open('https://qaintg.eyasp.in/aspgst/#/login', '_blank');
        break;
      // case 'KSA':
      //   window.open('https://www.eye-fatoorah-uat.com/?saml2idp=https://auugtkxur.accounts.ondemand.com', '_blank');
      //   break;
      case 'GBLD':
        window.open('https://demoeinvapp.eyasp.in/', '_blank');
        break;
      default:
        this.configureAndRedirectToHome();
        break;
    }
  }

  configureAndRedirectToHome() {
    let perm = Constants.countryPermList.find(x => x.ctyCode === this.selectedCountry).isPerm;
    this.storageService.setWithDefaultPassphrase("Country", this.selectedCountry);
    this.storageService.setWithDefaultPassphrase("Permission", perm);
    this.router.navigate(['home']);
  }

  showLogout() {
    this.confirmationService.confirm({
      message: 'Unsaved changes will be deleted. Do you want to continue?',
      acceptLabel: 'Yes',
      rejectLabel: 'No',
      rejectVisible: true,
      accept: () => {
        this.confirmationService.close();
      },
      reject: () => {
        return;
      }
    });
  }

  logout() {
    this.storageService.logOut(false);
  }

  startCountdown(seconds: number) {
    this.interval = setInterval(() => {
      if (seconds == 0) {
        clearInterval(this.interval);
        this.storageService.unAuthUserFound();
      }
    }, 1000);
  }

  continue() {
    clearInterval(this.interval);
  }

  cancel() {
    this.storageService.unAuthUserFound();
  }

  onCountryChange($event: any) {
    this.showError = false;
    this.selectedCountry = $event.target.value;
  }

}
